import { Quaternion, Vector3 } from 'three'

/**
 * A pose in **tracking space** — the player's real room, which is glued to the
 * rigid body. Everything upstream of the physics speaks tracking space; only
 * the rig transform converts to world (DESIGN.md §2).
 */
export interface Pose {
  position: Vector3
  quaternion: Quaternion
  tracked: boolean
}

export interface HandInput extends Pose {
  /** 0..1 analog trigger. */
  throttle: number
}

export interface PilotInput {
  head: Pose
  /** [left, right] */
  hands: [HandInput, HandInput]
}

export function makePose(): Pose {
  return { position: new Vector3(), quaternion: new Quaternion(), tracked: false }
}

export function makeHand(): HandInput {
  return { ...makePose(), throttle: 0 }
}

export function makePilotInput(): PilotInput {
  return { head: makePose(), hands: [makeHand(), makeHand()] }
}

/** Anything that can drive the pilot: XR controllers, a gamepad, a script, a replay. */
export interface InputSource {
  readonly name: string
  /** Fill `out` for this frame. */
  sample(out: PilotInput, dt: number): void
  dispose?(): void
}
